import React from "react";
import TextSlider from "./TextSlider";

const CharachaLekh = ({ text, handleShareData, sharetext }) => {
  return (
    <>
      <div className="container-fluid">
        <div className="episode_banner_pad_stick">
          <h3 className="charcha_head">
            Charcha ka lekh
            <sup>
              <img src="/assets/images/charchawing.svg" alt="" />
            </sup>
          </h3>
        </div>
      </div>

      <div className="charcha_slider">
        <TextSlider text={text} handleShareData={handleShareData} sharetext={sharetext} />
      </div>
    </>
  );
};

export default CharachaLekh;
